var popupForm = {
    element: null,
    open: function (containerId, afterClose) {
        var popupModal = createElement(`
            <div class="popup-form-backdrop">
                <div class="overflow">
                    <div class="modal">
                        <button class="close">
                            <span class="icon icon-exit2"></span>                
                        </button>                                                    
                        <div class="modal-content">  
                            <div class="loader"></div>    
                            <div class="form-container">
                                    
                            </div>                      
                        </div>
                    </div>
                </div>
            </div>
        `);

        var formHTML = document.querySelector(containerId);
        popupModal.querySelector('.form-container').appendChild(formHTML);

        popupModal.querySelector(".close").addEventListener('click', () => {
            this.close();
            afterClose();
        });

        document.body.style.overflow = "hidden";
        document.body.appendChild(popupModal);
        this.element = popupModal;

    },
    close: function () {
        document.body.style.overflow = "auto";
        this.element.remove();
    }
}

function openFeatureHubForm(formType) {
    var formId = `${formType}-form`;

    insert('body',
        `<div id="${formType}-form-container" class="feature-hub call-back-container">
            <div id="${formId}"></div>
         </div>`
    );

    var formCode = skodaVariables.formCodes[formType];
    var widget = getFormWidgetWithContextProps(formCode);

    var container = document.getElementById(formId);
    var loadGMaps = true;
    skodaVariables.featureHubIntegrator.load(widget, container, loadGMaps);

    var containerId = `#${formType}-form-container`;

    var afterClose = function () {
        window.lhSdriveTracking.sendPreviousView();
    }

    popupForm.open(containerId, afterClose);
}

function getFormWidgetWithContextProps(formCode) {
    let formContextProps = null;

    if (formCode.includes('?')) {
        const parts = formCode.split('?');
        formCode = parts[0];

        const props = parts[1] ? parts[1].split('&') : [];
        if (props.length > 0) {
            formContextProps = {};

            for (const prop of props) {
                const keyValue = prop.split('=');
                if (keyValue.length === 2) {
                    formContextProps[keyValue[0]] = keyValue[1];
                }
            }
        }
    }

    const widget = skodaVariables.featureHub.widgets.forms;
    widget.properties.config.formCode = formCode;

    if (formContextProps) {
        for (const key in formContextProps) {
            if (formContextProps.hasOwnProperty(key)) {
                widget.properties.config.formContext[key] = formContextProps[key];
            }
        }
    }

    return widget;
}

function createElement(html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content.firstChild;
}

function openCarConfigurator(_this) {
    var configuratorUrl = skodaVariables.configuratorUrl;
    var qsOption = `{"dealerid":"${skodaVariables.dealerID}"}`;
    var configuratorUrl = UpdateQueryString("options", qsOption, configuratorUrl);
    var $this = $(_this);
    var target = $this?.attr('target') || '_blank';
    window.open(configuratorUrl, target);
}

function openBookServiceForm() {
    if ($('html').data('onedealer-inquiry') === "True") {
        var $form = $('.book-service-form');

        if ($form.length > 0)
            $form.get(0).initPopUp();
    } else if (skodaVariables.featureHub.active) {

        openFeatureHubForm("bookService");

    } else {
        if (window.self !== window.top) {
            window.parent.insert('body', window.parent.skodaVariables.forms.bookService);

            window.parent.$.fancybox.open($("#bookService-form", window.parent.document), {
                afterClose: function () {
                    $("#bookService-form", window.parent.document).remove();
                    window.parent.lhSdriveTracking.sendPreviousView();
                }
            });
        } else {
            insert('body', skodaVariables.forms.bookService);

            $.fancybox.open($("#bookService-form"), {
                afterClose: function () {
                    $('#bookService-form').remove();
                    window.lhSdriveTracking.sendPreviousView();
                }
            });
        }
    }
}

function openContactForm() {
    if ($('html').data('onedealer-inquiry') === "True") {
        var $form = $('.contact-form');

        if ($form.length > 0)
            $form.get(0).initPopUp();
    } else if (skodaVariables.featureHub.active) {

        openFeatureHubForm("contact");

    } else {
        if (window.self !== window.top) {
            window.parent.insert('body', window.parent.skodaVariables.forms.contact);

            window.parent.$.fancybox.open($("#contact-form", window.parent.document), {
                afterClose: function () {
                    $("#contact-form", window.parent.document).remove();
                    window.parent.lhSdriveTracking.sendPreviousView();
                }
            });
        } else {
            insert('body', skodaVariables.forms.contact);

            $.fancybox.open($("#contact-form"), {
                afterClose: function () {
                    $('#contact-form').remove();
                    window.lhSdriveTracking.sendPreviousView();
                }
            });
        }    
    }
}

function openTestDriveForm() {
    if ($('html').data('onedealer-inquiry') === "True") {
        var $form = $('.book-test-drive-form');

        if ($form.length > 0)
            $form.get(0).initPopUp();
    } else if (skodaVariables.featureHub.active) {

        openFeatureHubForm("testDrive");

    } else {
        if (window.self !== window.top) {
            window.parent.insert('body', window.parent.skodaVariables.forms.testDrive);

            window.parent.$.fancybox.open($("#testDrive-form", window.parent.document), {
                afterClose: function () {
                    $("#testDrive-form", window.parent.document).remove();
                    window.parent.lhSdriveTracking.sendPreviousView();
                }
            });
        } else {
            insert('body', skodaVariables.forms.testDrive);

            $.fancybox.open($("#testDrive-form"), {
                afterClose: function () {
                    $('#testDrive-form').remove();
                    window.lhSdriveTracking.sendPreviousView();
                }
            });
        }
    }
}

function openRequestQuoteForm() {
    if ($('html').data('onedealer-inquiry') === "True") {
        var $form = $('.request-quote-form');

        if ($form.length > 0)
            $form.get(0).initPopUp();
    } else if (skodaVariables.featureHub.active) {

        openFeatureHubForm("requestQuote");

    } else {
        if (window.self !== window.top) {
            window.parent.insert('body', window.parent.skodaVariables.forms.quote);

            window.parent.$.fancybox.open($("#quote-form", window.parent.document), {
                afterClose: function () {
                    $("#quote-form", window.parent.document).remove();
                    window.parent.lhSdriveTracking.sendPreviousView();
                }
            });
        } else {
            insert('body', skodaVariables.forms.quote);

            $.fancybox.open($("#quote-form"), {
                afterClose: function () {
                    $('#quote-form').remove();
                    window.lhSdriveTracking.sendPreviousView();
                }
            });
        }
    } 
}

function openCarEvaluationForm() {
    if (window.self !== window.top) {
        window.parent.insert('body', window.parent.skodaVariables.forms.carEvaluation);

        window.parent.$.fancybox.open($("#carEvaluation-form", window.parent.document), {
            afterClose: function () {
                $("#carEvaluation-form", window.parent.document).remove();
                window.parent.lhSdriveTracking.sendPreviousView();
            }
        });
    } else if (skodaVariables.featureHub.active) {

        openFeatureHubForm("carEvaluation");

    } else {
        insert('body', skodaVariables.forms.carEvaluation);

        $.fancybox.open($("#carEvaluation-form"), {
            afterClose: function () {
                $('#carEvaluation-form').remove();
                window.lhSdriveTracking.sendPreviousView();
            }
        });
    }
}

function testdrivebooker(name) { //keyloop

    var model = name && name.split(' ')[0].toLowerCase();
    var analyticsConsent = window.skodaVariables.consents.analytics;    
    var allowGps = window.skodaVariables.iframeGPS ;
;    
    var keyLoopForm = `
            <div id="keyloop-form" class="test-drive-container" style="display: none;">
                <div class="test-drive-popup">
                    <div class="iframe-container">
                        <iframe src="https://testdrivebooker.eu.keyloop.io/helkamabeta?brand=Skoda&amp;model=${model}&amp;allowTracking=${analyticsConsent}&amp;language=fi&amp;origin=https://www.helkama-autokauppa.fi"
                                width="100%"
                                scrolling="yes"
                                style="height:836px"
                                ${allowGps ? 'allow="geolocation"' : ''}>
                        </iframe>
                    </div>
                </div>
            </div>`;

    if (window.self !== window.top) {
        window.parent.insert('body', keyLoopForm);

        window.parent.$.fancybox.open($("#keyloop-form", window.parent.document), {
            afterClose: function () {
                $("#keyloop-form", window.parent.document).remove();
                window.parent.lhSdriveTracking.sendPreviousView();
            }
        });
    } else {
        insert('body', keyLoopForm);

        $.fancybox.open($("#keyloop-form"), {
            afterClose: function () {
                $('#keyloop-form').remove();
                window.lhSdriveTracking.sendPreviousView();
            }
        });
    }
}

(function () {
    if (skodaVariables.featureHub.active) {
        skodaVariables.featureHub.widgets.forms = {
            properties: {
                featureAppId: 'Skoda:FormsFeatureApp',
                src: 'forms-feature-app.umd.js',
                baseUrl: "https://forms.skoda-auto.com/",
                localeServiceConfig: skodaVariables.featureHub.localeServiceConfig,
                config: {
                    formCode: '',
                    isTemp: false,
                    formContext: {
                        dealerId: skodaVariables.dealerID,
                        integrator: skodaVariables.widgetTracking.pageGroup
                    },
                    actions: {
                        onSubmitSuccess: (answerId, formAnswer) => {
                            if (skodaVariables.featureHub.formThankYouPage === '') {
                                console.error('Error: submit success is missing thank you page Url');
                                return;
                            }
                            window.location = skodaVariables.featureHub.formThankYouPage;
                        },
                        onSubmitError: (error) => {
                            console.error('Submit error:', error);
                        }
                    },
                    tracking: {
                        "page.Group": skodaVariables.widgetTracking.pageGroup,
                        "page.Context": skodaVariables.widgetTracking.pageContext
                    },
                    externalTrackingData: {                        
                        "page.Group": skodaVariables.widgetTracking.pageGroup,
                        "page.Context": skodaVariables.widgetTracking.pageContext              
                    }
                }
            }
        };      

        const featureHubFormContainer = document.getElementById("feature-hub-form");
        if (!featureHubFormContainer) return;

        function inlineForm() {
            const formType = featureHubFormContainer.getAttribute('data-form-type');
            const formCode = skodaVariables.formCodes[formType];

            const widget = getFormWidgetWithContextProps(formCode);
            const container = featureHubFormContainer;
            const loadGMaps = true;
            skodaVariables.featureHubIntegrator.load(widget, container, loadGMaps);
        }

        const similarCarsContainer = document.getElementById("root-similar-cars");
        if (similarCarsContainer) {
            // load homepage feature hub form after similar cars is loaded (react createRoot is asynchronous)
            const observer = new MutationObserver(function (mutationsList, observer) {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        inlineForm();
                        observer.disconnect(); //stop observing after the first load
                    }
                }
            });
            observer.observe(similarCarsContainer, { childList: true });
        } else {
            inlineForm();
        }
    }
})();